export enum $viewIssuesParams {
  dismissedFilter = 'dismissedFilter',
  advancedSearch = 'advancedSearch',
  issueId = 'issueId',
}
